/**
 * Destino de navegação interno e seguro (contra open redirect).
 * Aceita só caminhos do próprio SPA: começa com `/`, não com `//` nem `/\`, sem caracteres de controle
 * (o navegador ignora `\t`/`\r`/`\n` ao interpretar a URL, o que transformaria `/\t/evil.com` em `//evil.com`).
 */
export const DESTINO_PADRAO = '/app/inicio';
const CARACTERE_DE_CONTROLE = /[\u0000-\u001f\u007f]/;
export function destinoSeguro(valor) {
    if (typeof valor !== 'string' || !valor.startsWith('/'))
        return null;
    if (valor.startsWith('//') || valor.startsWith('/\\'))
        return null;
    if (CARACTERE_DE_CONTROLE.test(valor))
        return null;
    return valor;
}
/** Destino após o login: a rota que o `ProtectedRoute` guardou em `state.from`, ou o início. */
export function destinoPosLogin(location) {
    const from = location?.state?.from;
    if (!from?.pathname)
        return DESTINO_PADRAO;
    const destino = destinoSeguro(`${from.pathname}${from.search ?? ''}${from.hash ?? ''}`);
    // Voltar à própria tela de login criaria um laço com o PublicRoute.
    if (!destino || destino.startsWith('/app/login'))
        return DESTINO_PADRAO;
    return destino;
}
